/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { List, ListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styles from '../../styles/footerStyle.js';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FONT_FAMILY} from "../../common/sharedFunctions.js"

const useStyles = makeStyles(styles);


export default function HomeFooter(props) {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.homeFooter]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const footerLinks = [
    { label: t('home'), to: '/' },
    { label: t('myaccount'), to: '/bookings' },
    { label: t('about_us'), to: '/about-us' },
    { label: t('contact_us'), to: '/contact-us' },
    { label: t('privacy_policy'), to: '/privacy-policy' },
    { label: t('term_condition'), to: '/term-condition' }
  ];

  return (
    <footer className={footerClasses}>
      <div
        className={classNames(classes.container, classes.homeContainer)}
        style={{direction:isRTL === 'rtl' ? 'rtl' : 'ltr'}}
      >
        <nav className={classes.homeNavigation} aria-label="Footer navigation">
          <List className={classNames(classes.list, classes.homeList)}>
            {footerLinks.map((item) => (
              <ListItem className={classes.inlineBlock} key={item.to}>
                <Link
                  className={classNames(classes.block, classes.homeLink)}
                  style={{fontFamily: FONT_FAMILY}}
                  to={item.to}
                >
                  {item.label}
                </Link>
              </ListItem>
            ))}
          </List>
        </nav>
        {settings && settings.CompanyName ? (
          <div className={classes.homeCopyright} style={{fontFamily: FONT_FAMILY}}>
            &copy; {new Date().getFullYear() + " "}
            {settings.CompanyWebsite ? (
              <a
                className={classes.homeCompanyLink}
                href={settings.CompanyWebsite}
                rel="noreferrer"
                target="_blank"
              >
                {settings.CompanyName}
              </a>
            ) : settings.CompanyName}
          </div>
        ) : null}
      </div>
    </footer>
  );
}

HomeFooter.propTypes = {
  whiteFont: PropTypes.bool
};
